const INITIAL_STATE = { urls: null, done: false };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'IMAGE_URL':
      return {
        ...state,
        urls: state.urls ? [action.url, ...state.urls] : [action.url]
      };
    case 'IMAGE_URL_STATUS':
      return {
        ...state,
        done: action.done
      };
    case 'IMAGE_INIT':
      return INITIAL_STATE;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/ImageReducer.js